module.exports = __webpack_public_path__ + "static/media/www.mangodiscobar.fi.14dcb8aa.jpg";